import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()((theme) => ({
  inputMargin: {
    marginRight: '1em',
  },
  participantTableActionContainer: {
    minHeight: 80,
  },
  indexCell: {
    borderBottom: 'none',
    width: '40px',
  },
  dragTableHeaderCell: {
    fontSize: '10px',
    minWidth: '40px',
    maxWidth: '40px',
    padding: 0,
    width: '40px',
  },
  dragTableHeaderCellDisabled: {
    color: theme.palette.grey[300],
  },
  buttonIcon: {
    height: '16px',
    marginRight: theme.spacing(1),
    stroke: theme.palette.grey['50'],
    width: 'auto',
  },
}));
